var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 18,
    viewBox: "0 0 8 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91578 0.174805C4.55978 0.174805 5.06578 0.335805 5.43378 0.657805C5.81711 0.964472 6.00878 1.39381 6.00878 1.94581C6.00878 2.4978 5.81711 2.9348 5.43378 3.2568C5.06578 3.56347 4.55978 3.7168 3.91578 3.7168C3.27178 3.7168 2.75811 3.56347 2.37478 3.2568C2.00678 2.9348 1.82278 2.4978 1.82278 1.94581C1.82278 1.39381 2.00678 0.964472 2.37478 0.657805C2.75811 0.335805 3.27178 0.174805 3.91578 0.174805ZM5.70978 15.8608C5.70978 16.4895 5.81711 16.9265 6.03178 17.1718C6.26178 17.4018 6.64511 17.5168 7.18178 17.5168V17.9998C5.64845 17.9385 4.62878 17.9078 4.12278 17.9078C3.64745 17.9078 2.58178 17.9385 0.925781 17.9998V17.5168C1.47778 17.5168 1.86111 17.4018 2.07578 17.1718C2.29045 16.9265 2.39778 16.4895 2.39778 15.8608V8.6158C2.39778 7.91047 2.29045 7.39681 2.07578 7.07481C1.86111 6.75281 1.47778 6.5918 0.925781 6.5918V6.1088C1.41645 6.15481 1.89178 6.17781 2.35178 6.17781C3.71645 6.17781 4.83578 6.07047 5.70978 5.85581V15.8608Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8d5587a2fe5e53a36a282a9b6e42ab55.svg";
export { ForwardRef as ReactComponent };